import { z } from "zod";

export const ApplyDiscountCodeSchema = z.object({
  basketId: z.string(),
  discountCode: z.string().trim().min(1, { message: "Code invalide" }),
});

export const RemoveDiscountCodeSchema = z.object({
  basketId: z.string(),
  discountCodeId: z.string().trim().min(1),
});

export type ApplyDiscountCodeForm = z.infer<typeof ApplyDiscountCodeSchema>;
export type RemoveDiscountCodeForm = z.infer<typeof RemoveDiscountCodeSchema>;
